import http from "../../backend/http.js";

async function getType(id) {
  try {
    const response = await http.get(`crm/sales-funnel-types/${id}`);
    return {
      id: response.data.id,
      title: response.data.title,
      date: response.data.date,
      stages: response.data.salesFunnelStages,
    };
  } catch (err) {
    throw err;
  }
}

async function updateType(id, data) {
  try {
    const response = await http.put(`crm/sales-funnel-types/${id}`, data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createType(data) {
  try {
    const response = await http.post("crm/sales-funnel-types", data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getTypes(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `crm/sales-funnel-types?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectType(
    page = 1,
    rowsPerPage = 9,
    search = ""
) {
  try {
    const response = await http.get(
      "crm/sales-funnel-types/references", {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}
async function updateTypeStages(id, data) {
  try {
    const response = await http.put(`crm/sales-funnel-types/${id}/stage-orders`, data);
    return response;
  } catch (err) {
    throw err;
  }
}


export { getType, updateType, selectType, getTypes, createType, updateTypeStages };
